'use strict';

import type { IndPortalLog } from '../../Entities/Ind/IndPortalLog';
import { EntityCollection } from '../EntityCollection';

export class IndPortalLogCollection extends EntityCollection<IndPortalLog> {}
